/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './HeaderEmbedSim.css';
import ContainerHome24 from '../../atoms/ContainerHome24';

function HeaderEmbedSim({ importPrefix }) {
  return (
    <>
      <header>
        <ContainerHome24>
          <a href={`${importPrefix}.`} id="logo-santander-header-desktop">
            <img
              src={`${importPrefix}static/amp/shared/assets/logo_2.svg`}
              alt="Logo Santander Financiamentos"
              height="19"
              width="239"
            />
          </a>
        </ContainerHome24>
      </header>
      <style jsx>{Style}</style>
    </>
  );
}

HeaderEmbedSim.defaultProps = {
  importPrefix: '',
};

export default HeaderEmbedSim;
